import { render, staticRenderFns } from "./addNewPlan.vue?vue&type=template&id=3d91a515&scoped=true&"
import script from "./addNewPlan.vue?vue&type=script&lang=js&"
export * from "./addNewPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91a515",
  null
  
)

export default component.exports